<template>
  <div  v-show="pageMsg.totalRecords>0">
   <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageMsg.pageNo"
      :page-size="pageMsg.pageSize"
      :layout="layout"
      :total="pageMsg.totalRecords"
      :page-sizes="pageSizes"
      :pager-count="pagerCount"
    ></el-pagination>
  </div>
</template> 

<script> 
export default { 
  name:"ElPageCover",
  data: function() {
    return {};
  },
  props: {
    pageMsg: {
      //分页信息对象， 后端标准规范：分页对象属性
      type: Object,
      default: function() {
        return {
          pageSize: 10,
          pageNo: 1,
          totalRecords: 0
        };
      }
    },
    layout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper" //
    },
    pageSizes: {
      //可选择的分页条数
      type: Array,
      default: function() {
        return [5,10];
      }
    },
    pagerCount: {
      type: Number,
      //显示可点击的页码数量，5~21之间的奇数
      default: 5
    }
  },
  methods: {
    handleSizeChange: function(size) {
      this.$emit("sizeChange", size);
    },
    handleCurrentChange: function(index) {
      this.$emit("currentChange", index);
    }
  },
  watch: {},
  mounted() {}
};
</script>